/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {Layers} from "@mui/icons-material";
import {useEffect, useState} from "react";
import {obtenerCol} from "../../Servicios/BD/obtenerCol";
import IngresoSelectPropId from "../../Modulo_formularios/Componentes/IngresoSelectPropId";
import IngresoImagenCropLista from "../../Modulo_formularios/Componentes/IngresoImagenCropLista";


const Formulario_Fotos = ({...props}) => {
    const [colecciones, setColecciones] = useState([])

    useEffect(() => {

        obtenerCol('colecciones').then((dox) => {
            setColecciones(dox.data)
        })

    }, [])

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography sx={{fontSize: 14}}>Estado y Coleccion</Typography>
                </Grid>


                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelectPropId Icono={Layers} nombre={'Coleccion'} propiedad={'nombre'} propiedadId={'id'}
                                         dato={'coleccion'} datoId={'idColeccion'}{...props}
                                         opciones={colecciones}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography sx={{fontSize: 14}}>Fotos en diferentes poses o esenarios de un mismo set</Typography>
                </Grid>

                <Grid container size={12}>
                    <IngresoImagenCropLista alto={14} ancho={10}
                                            dato={'imgs'} {...props}

                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Fotos